import $ from 'jquery';
import openModal from '../../components/INF-Modal/openModal';
import closeAllMenus from '../../core/INF-closeAllMenus';

export default function() {
  $(document).on('shopify:section:load', (e) => {
    if (e.detail.sectionId !== 'INF-ForgotPassword') { return; }
    
    openModal($('#recover'));
  });
  
  $(document).on('shopify:section:select', (e) => {
    if (e.detail.sectionId === 'INF-ForgotPassword') { 
      openModal($('#recover'));
    }
    if (e.detail.sectionId === 'INF-LoginPage') { 
      closeAllMenus();
    }
  });

  $(document).on('shopify:section:deselect', (e) => {
    if (e.detail.sectionId !== 'INF-ForgotPassword') { return; }

    closeAllMenus();
  });
}